import { render, staticRenderFns } from "./IntranetWorkerPage.vue?vue&type=template&id=228b2545&"
import script from "./IntranetWorkerPage.vue?vue&type=script&lang=js&"
export * from "./IntranetWorkerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports